export default "__VITE_ASSET__aafa13e3__"